import React from 'react';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useThemeMode } from '../../theme/ThemeModeContext';
import { MoonIcon, SunIcon } from '../icons';

/** Round bordered button that toggles between light and dark mode. */
export default function ThemeToggle() {
  const { mode, toggleMode } = useThemeMode();
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={toggleMode}
      aria-label={t('header.toggleTheme')}
      sx={(theme) => ({
        width: 48,
        height: 48,
        borderRadius: '9999px',
        border: `1px solid ${theme.app.border}`,
        color: theme.app.foreground,
      })}
    >
      {mode === 'light' ? <MoonIcon /> : <SunIcon />}
    </IconButton>
  );
}
